import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { PRODUCTS } from '../data/products';
import ProductCard from '../components/ProductCard';

const ProductsIndexPage: React.FC = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-light-blue text-dark-blue">
      <section className="mx-auto max-w-5xl px-4 py-16">
        <div className="mb-10 space-y-3">
          <h1 className="text-3xl font-black md:text-4xl">
            {language === 'en' ? 'Marketplace Products' : 'Produk Marketplace'}
          </h1>
          <p className="max-w-2xl text-base text-gray-600 md:text-lg">
            {language === 'en'
              ? 'Explore Ourdo featured sessions and products designed for personal and community growth.'
              : 'Jelajahi sesi dan produk unggulan Ourdo untuk pertumbuhan personal maupun komunitas.'}
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {PRODUCTS.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              locale={language}
              className="w-full"
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProductsIndexPage;
